import minorCircuit from 'src/circuits/minor-circuit/locales'
import taxationCircuit from 'src/circuits/taxation-circuit/locales'
import global from 'src/locales/global'
import sharedCircuit from 'src/shared/xstate/ui/locales'
import indicatorsCircuit from 'src/tpbp-core/indicators-circuit/indicators-circuit.locales'
import transmissionCircuit from '../src/circuits/transmission-circuit/locales'
import contractWarnings from '../src/components/dmp/ContractWarnings/contract-warnings.locales'
import dashboard from '../src/pages/Dashboard/locales/index'
import selfCareV2DMP from '../src/pages/PatrimonyDevelopment/self-care/dmp-situation/locales/index'
import checkCareer from '../src/pages/RetreatIndicatorsSynthesis/steps/current-situation-retirement-warning/current-situation-retirement-warning.locales'
import suitabilityReport from '../src/pages/SuitabilityReport/locales'
import patrimonyEstimationAmount from '../src/pages/patrimony/PatrimonyEstimationAmount/patrimony-estimation-amount.locales'
import highcharts from '../src/plugins/highcharts/highChartsLocales'
import dashboardTiles from '../src/tpbp-ds/components/dashboard-tile/dashboard-tiles.locales'
import calendar from '../src/tpbp-ds/components/ws-ds-date-picker/calendar-fr'
import components from './components'
import fr from './fr.json'

export const messages = {
  ...fr,
  global,
  sharedCircuit,
  transmissionCircuit,
  taxationCircuit,
  minorCircuit,
  selfCareV2DMP,
  dashboard,
  patrimonyEstimationAmount,
  components,
  highcharts,
  indicatorsCircuit,
  dashboardTiles,
  contractWarnings,
  checkCareer,
  calendar,
  suitabilityReport
}
